module.exports = __webpack_public_path__ + "img/create-new-event-logo.b69b20aa.png";